import { MenuItem } from "./menu.model";

export const MENU: MenuItem[] = [
    {
        id: 0,
        label: 'MENU.menu',
        isTitle: true,
        hidden: false
    },
    {
        id: 1,
        label: 'MENU.dashboards',
        icon: 'monitor-dot',
        link: '',
        hidden: false

    },

    {
        id: 2,
        label: 'MENU.users',
        icon: 'user',
        link: '/menu-user-list',
        hidden: true
    },
    {
        id: 3,
        label: 'MENU.mainAccount',
        icon: 'shopping-bag',
        link: '/menu-bags-list',
        hidden: true
    },
    {
        id: 4,
        label: 'MENU.roles',
        icon: 'key-round',
        link: '/menu-list-role',
        hidden: true
    },
    {
        id: 5,
        label: 'MENU.account',
        icon: 'user-check',
        link: '/menu-list-account',
        hidden: true
    },
    {
        id: 6,
        label: 'MENU.contracts',
        icon: 'wallet',
        link: '/menu-list-contract',
        hidden: true
    },
]